export const VERIFICATION_TYPES = {
    TWO_FA: '2fa',
    IDENTITY: 'Identity',
    EDUCATION: 'Education',
    EMPLOYMENT: 'Employment',

    //intentionally not used _ because api response using camelCase eg. professionalLicense
    PROFESSIONALLICENSE: 'Professional License',
};
